<template>
    <Header />
    <div class="mainContent">
        <div class="LoginIndex">
        <a-row justify="center" class="LoginIndexSignBoxRow">
            <a-col :xs="24" :sm="16" :md="16" :lg="16" :xl="10">
            <div class="LoginIndexSignBox">
                <h2>個人資料維護</h2>
                
                <a-row justify="end">
                    <a-col>標示<a-typography-text type="danger">*</a-typography-text>為必填欄位</a-col>
                </a-row>

                <!-- <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <a-form-item label="帳號"   :rules="[{ required: true }]">
                        <a-input v-model:value="localData.AC_USERID" disabled />
                    </a-form-item>
                    <a-form-item v-for="(item,index) in token.data" :key="index" :label="'token'+(index+1)" name="link">
                        <p style="word-wrap:break-word;">{{item}}</p>
                    </a-form-item>
                    <a-form-item label="中文姓名"  :rules="[{ required: true }]">
                        <a-input v-model:value="localData.AC_USERNAME" placeholder="請輸入您的中文姓名" />
                        <a-typography-text type="danger">請填寫真實中文姓名(外籍會員請使用護照英文名字)</a-typography-text>
                    </a-form-item>
                    <a-form-item label="學校/單位名稱" >
                        <a-input v-model:value="localData.AC_CONTENT" placeholder="請輸入您的學校/單位名稱" />
                    </a-form-item>
                </a-form> -->

                <a-divider />
    
                <a-row justify="end">

                    <a-space :size="size">
                        <!-- <a-button size="large">不同意</a-button> -->
                        <a-button size="large" type="primary" html-type="submit" @click="checkData">確定</a-button>
                    </a-space>
                </a-row>
            </div>
            </a-col>
        </a-row>

        </div>
    </div>

</template>
  
<script>

import Header from '@/components/Header.vue';
export default {
  components: {
    Header
  }
}


</script>